import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/iconfont/iconfont.css'
// ElementPlus完整引入
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 全局指令引入
import defineDirective from '@/directives'

// 全局组件引入
import Component from '@/components'

// app
const app = createApp(App)
// 在引入 Element Plus 时，可以传入一个包含 size 和 zIndex 属性的全局配置对象。 size 用于设置表单组件的默认尺寸，zIndex 用于设置弹出组件的层级，zIndex 的默认值为 2000。
// Element Plus 组件默认使用英语，zhCn为中文
app.use(ElementPlus, { locale: zhCn, zIndex: 3000 })
// app.use(ElementPlus, { locale: zhCn, size: 'small', zIndex: 3000 })
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
// 全局指令
app.use(defineDirective)
// 全局组件
app.use(Component)
// vuex
app.use(store)

// router路由
app.use(router)
app.mount('#app')
